export const TourFormAllowedFields = [
  "transport_agent_id",
  "name",
  "description",
  "active",
  "is_default",
  "middle_mile_digital",
  "third_party",
  "delivery_timings",
  "delivery_timing_configs",
  "allowed_supplier_locations",
  "supplier_location_id",
  "tour_type_category",
  "user_defined_tour_id",
  "route_type",
  "tour_type",
  "stops",
  "custom_route_enabled",
  "custom_routes",
  "color",
  "confirm_vrp_reset",
];

export const CustomerFormAllowedFields = [
  "number",
  "tour_id",
  "tour_mappings",
  "name",
  "street",
  "street_number",
  "city",
  "zipcode",
  "country",
  "email",
  "phone",
  "latitude",
  "longitude",
  "deposit_agreement",
  "keybox_code",
  "contact_name",
  "contact_surname",
  "contact_salutation",
  "email_notifications",
  "active",
  "tour_manually_assigned",
  "priority",
  "supplier_id",
  "duplicate",
  "formatted_address",
  "default_remarks",
];

export const OrderFormAllowedFields = [
  "customer_id",
  "description",
  "departure",
  "departure_date",
  "remarks",
  "express",
  "supplier_location_id",
  "delivery_notes",
  "order_type",
];
export const SupplierLocationFormAllowedFields = [
  "name",
  "street",
  "street_number",
  "city",
  "zipcode",
  "country",
  "email",
  "phone",
  "latitude",
  "longitude",
  "supplier_id",
  "formatted_address",
];
export const SupplierFormAllowedFields = [
  "name",
  "street",
  "street_number",
  "city",
  "zipcode",
  "country",
  "email",
  "phone",
  "latitude",
  "longitude",
  "supplier_group_id",
  "number",
  "formatted_address",
];
export const UserAllowedFields = [
  "email",
  "password",
  "name",
  "surname",
  "supplier_id",
  "supplier_location_id",
  "role_id",
  "active",
  "permissions",
];
export const ZipcodeFormAllowedFields = ["zipcode", "tour_id", "tour_mappings", "supplier_ids", "country"];
